import Spinner from "@components/Spinner";
export default function AuthorizeLoading() {
  return (
    <div className="h-full w-full absolute flex flex-col  items-center justify-center">
      <Spinner />
      <span className="text-muted-fg mt-5">Authorizing ... </span>
    </div>
  );
}
